const sizes = {
    xsmall: 24,
    small: 32,
    medium: 40,
    large: 56,
    xlarge: 88,
}

export default sizes
